import DOMPurify from "dompurify";

const ALLOWED_TAGS = ["p", "br", "strong", "b", "em", "i", "u", "s", "h2", "h3", "h4", "ul", "ol", "li", "a", "blockquote"];

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer nofollow");
  }
});

export const cleanHtml = (html) => DOMPurify.sanitize(html || "", { ALLOWED_TAGS, ALLOWED_ATTR: ["href", "target", "rel"] });
